import React, { useState } from "react";

const media = [
  { url: "https://egmoreayyappantempleapms.in/images/gallery.jpeg", type: "image" },
  { url: "https://egmoreayyappantempleapms.in/images/gallery-1.jpeg", type: "image" },
  // { url: "https://panchamidevi.in/images/img-3.jpg", type: "image" },
  // { url: "https://panchamidevi.in/images/img-4.jpg", type: "image" },

  // { url: "https://panchamidevi.in/images/img-5.jpg", type: "image" },
  // { url: "https://panchamidevi.in/images/img-6.jpeg", type: "image" },
  // { url: "https://panchamidevi.in/images/img-7.jpeg", type: "image" },
  // { url: "https://panchamidevi.in/images/img-8.jpeg", type: "image" },
  // { url: "https://panchamidevi.in/images/img-9.jpeg", type: "image" },
  // { url: "https://panchamidevi.in/images/img-10.jpeg", type: "image" },
  // { url: "https://panchamidevi.in/images/img-11.jpeg", type: "image" },
  // { url: "https://panchamidevi.in/images/img-12.jpeg", type: "image" },


  // { url: "https://panchamidevi.in/images/video-1.mp4", type: "video" },
  // { url: "https://panchamidevi.in/images/video-2.mp4", type: "video" },
];

function PhotoGallery() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openModal = (index) => setSelectedIndex(index);
  const closeModal = () => setSelectedIndex(null);

  const prevItem = () =>
    setSelectedIndex((prev) => (prev === 0 ? media.length - 1 : prev - 1));

  const nextItem = () =>
    setSelectedIndex((prev) => (prev === media.length - 1 ? 0 : prev + 1));

  return (
    <div>
     
      <div className="row banner" style={{display: 'flex', alignItems: 'center', justifyContent: 'center',backgroundImage:'url(./images/slider/slider-1.png)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{marginTop:'50px',marginBottom:"50px"}}>
        <div style={galleryStyle}>
          {media.map((item, index) => (
            <div key={index} style={itemStyle} onClick={() => openModal(index)}>
              {item.type === "image" ? (
                <img src={item.url} alt="" style={imgStyle} />
              ) : (
                <video src={item.url} style={videoStyle} muted />
              )}
            </div>
          ))}
        </div>
      </div>

      {selectedIndex !== null && (
        <div style={modalOverlay} onClick={closeModal}>
          <div style={modalContent} onClick={(e) => e.stopPropagation()}>
            <span style={closeBtn} onClick={closeModal}>×</span>

            <button style={navBtnLeft} onClick={prevItem}>❮</button>

            {media[selectedIndex].type === "image" ? (
              <img src={media[selectedIndex].url} style={modalMedia} />
            ) : (
              <video src={media[selectedIndex].url} controls autoPlay style={modalMedia} />
            )}

            <button style={navBtnRight} onClick={nextItem}>❯</button>
          </div>
        </div>
      )}
    </div>
  );
}



/* ✅ STYLES (DEFINED ONLY ONCE) */

const galleryStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
  gap: "15px",
};

const itemStyle = {
  height: "220px",
  borderRadius: "8px",
  overflow: "hidden",
  cursor: "pointer",
};

const imgStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};

const videoStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};

/* MODAL */

const modalOverlay = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.9)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalContent = {
  position: "relative",
  maxWidth: "90%",
  maxHeight: "90%",
};

const modalMedia = {
  maxWidth: "100%",
  maxHeight: "90vh",
};

const closeBtn = {
  position: "absolute",
  top: "-40px",
  right: "0",
  fontSize: "30px",
  color: "#fff",
  cursor: "pointer",
};

const navBtnLeft = {
  position: "absolute",
  left: "-50px",
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: "30px",
  background: "none",
  border: "none",
  color: "#fff",
  cursor: "pointer",
};

const navBtnRight = {
  ...navBtnLeft,
  left: "auto",
  right: "-50px",
};

export default PhotoGallery;

